import config from "@/config";
import fetchWrapper from "@/services/fetchWrapper.service";

export const ARTWORK_PREFERENCE_SIGNALS = Object.freeze({
  ADD_TO_ARTLIST: "add_to_artlist",
  PURCHASE_INTENT: "purchase_intent",
  MORE_DETAILS_MOBILE: "more_details_mobile",
  SHARE: "share",
  ARTIST_PROFILE_VIEW_FROM_ARTWORK: "artist_profile_view_from_artwork",
  GALLERY_PROFILE_VIEW_FROM_ARTWORK: "gallery_profile_view_from_artwork",
});

export const FACET_PREFERENCE_SIGNALS = Object.freeze({
  CATEGORY_CARD_CLICK: "category_card_click",
  SEARCH_FILTER_APPLY: "search_filter_apply",
});

function normalizeSlug(slug) {
  if (typeof slug !== "string") {
    return null;
  }
  const trimmed = slug.trim();
  return trimmed || null;
}

export async function trackArtworkPreferenceInteraction({ slug, signal, metadata } = {}) {
  const normalizedSlug = normalizeSlug(slug);
  if (!normalizedSlug || typeof signal !== "string") {
    return false;
  }

  try {
    const { response } = await fetchWrapper.post(
      `${config.apis.api.url}/artwork/interaction/${encodeURIComponent(normalizedSlug)}`,
      {
        injectToken: true,
        body: {
          signal,
          metadata: metadata && typeof metadata === "object" ? metadata : undefined,
        },
      }
    );

    return Boolean(response?.ok);
  } catch (_error) {
    return false;
  }
}

function normalizeFacetPayload(facets) {
  if (!facets || typeof facets !== "object") {
    return null;
  }

  const normalizeFacetList = (value) =>
    Array.isArray(value)
      ? value
        .map((entry) => (typeof entry === "string" ? entry.trim() : ""))
        .filter(Boolean)
      : [];

  const normalized = {
    themes: normalizeFacetList(facets.themes),
    feelings: normalizeFacetList(facets.feelings),
    colors: normalizeFacetList(facets.colors),
    mediums: normalizeFacetList(facets.mediums),
  };

  const hasValues = Object.values(normalized).some((value) => value.length > 0);
  return hasValues ? normalized : null;
}

export async function trackFacetPreferenceInteraction({ signal, source, facets } = {}) {
  const normalizedSignal = typeof signal === "string" ? signal.trim() : "";
  const normalizedSource = typeof source === "string" ? source.trim() : "";
  const normalizedFacets = normalizeFacetPayload(facets);

  if (!normalizedSignal || !normalizedSource || !normalizedFacets) {
    return false;
  }

  try {
    const { response } = await fetchWrapper.post(
      `${config.apis.api.url}/preference/facet-interaction`,
      {
        injectToken: true,
        body: {
          signal: normalizedSignal,
          source: normalizedSource,
          facets: normalizedFacets,
        },
      }
    );

    return Boolean(response?.ok);
  } catch (_error) {
    return false;
  }
}
